import { createReducer, on } from '@ngrx/store';
import { CanalVenta, CanalVentaForm } from '@core/models';
import {
  SALE_CHANNEL_FIND_SUCCESS,
  SALE_CHANNEL_FAILURE,
  SALE_CHANNEL_UPDATE_FORM,
  SALE_CHANNEL_RESET_ERROR,
  SALE_CHANNEL_RESET,
  SALE_CHANNEL_RESET_FORM,
  SALE_CHANNEL_FIND_ALL_SUCCESS,
  SALE_CHANNEL_EDIT_MODE,
  SALE_CHANNEL_CLEAR_STATE,
  SALE_CHANNEL_UPDATE_LOADING,
  SALE_CHANNEL_UPDATE_ID,
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces/response-bad-request';
import { transformSaleChannelData } from '@core/helpers';

export interface SaleChannelState {
  loading: boolean;
  saleChannelList: CanalVenta[] | null;
  error: ResponseBadRequest | null;
  editMode: boolean;
  isEditing: boolean;
  saleChannelForm: CanalVentaForm | null;
  saleChannelId: string | null;
  saleChannel: CanalVenta | null;
}

export const initialState: SaleChannelState = {
  loading: false,
  saleChannelList: null,
  error: null,
  editMode: false,
  isEditing: false,
  saleChannelForm: null,
  saleChannelId: null,
  saleChannel: null,
};

export const saleChannelReducer = createReducer(
  initialState,
  on(SALE_CHANNEL_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(SALE_CHANNEL_FIND_SUCCESS, (state, { saleChannel }) => ({ ...state, saleChannel: transformSaleChannelData(saleChannel) })),
  on(SALE_CHANNEL_FIND_ALL_SUCCESS, (state, { saleChannelList }) => ({ ...state, saleChannelList })),
  on(SALE_CHANNEL_FAILURE, (state, { error }) => ({ ...state, error })),
  on(SALE_CHANNEL_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(SALE_CHANNEL_UPDATE_FORM, (state, { saleChannelForm }) => ({ ...state, saleChannelForm })),
  on(SALE_CHANNEL_UPDATE_ID, (state, { saleChannelId }) => ({ ...state, saleChannelId })),
  on(SALE_CHANNEL_RESET, (state) => ({ ...state, saleChannel: null, saleChannelId: null, saleChannelForm: null })),
  on(SALE_CHANNEL_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(SALE_CHANNEL_RESET_FORM, (state) => ({ ...state, saleChannelForm: null, loading: false })),
  on(SALE_CHANNEL_CLEAR_STATE, () => initialState),
);
